/* REQ-033 · election sale: countdown, one expiry state, strip marquee, home hero rotation. No dependencies.
   The end time comes only from the theme setting `campaign_end`, written by snippets/pm-campaign-head.liquid
   as <html data-pm-campaign-end="<epoch ms>">. */
(function () {
  var root = document.documentElement;
  var END = parseInt(root.getAttribute('data-pm-campaign-end'), 10);
  if (!END) return;
  var SKEW = parseInt(root.getAttribute('data-pm-campaign-skew'), 10) || 0; // see pm-campaign-head.liquid
  function now() { return Date.now() + SKEW; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function end() {
    if (root.classList.contains('pm-campaign-ended')) return;
    root.classList.remove('pm-campaign-live', 'pmc-pal-bordeaux');
    root.classList.add('pm-campaign-ended');
    // the announcement bar shrinks back to 32px: let the header offset logic re-measure
    window.dispatchEvent(new Event('resize'));
  }

  /* ---------- countdown ---------- */
  function parts(t) {
    t = Math.max(0, Math.floor(t / 1000));
    return [Math.floor(t / 3600), Math.floor(t % 3600 / 60), t % 60].map(function (v) { return String(v).padStart(2, '0'); });
  }
  function setRoll(el, txt) {
    if (!el._d) { el.classList.add('pmc-roll'); el.textContent = ''; el._d = []; }
    while (el._d.length < txt.length) {
      var s = document.createElement('span'); s.className = 'dg'; s.appendChild(document.createElement('i'));
      el.appendChild(s); el._d.push(s);
    }
    txt.split('').forEach(function (ch, i) {
      var box = el._d[i], cur = box.lastElementChild;
      if (cur.textContent === ch) return;
      if (!cur.textContent || reduce) { cur.textContent = ch; return; }
      var nx = document.createElement('i'); nx.className = 'in'; nx.textContent = ch; box.appendChild(nx);
      void nx.offsetWidth; cur.className = 'out'; nx.className = ''; // reflow, then animate: no rAF (paused in background tabs)
      box.querySelectorAll('i.out').forEach(function (o) { if (o !== cur) o.remove(); });
      setTimeout(function () { if (cur.parentNode) cur.remove(); }, 380);
    });
  }
  var timer;
  function tick() {
    var left = END - now();
    if (left <= 0) { end(); clearInterval(timer); return; }
    root.classList.toggle('pm-campaign-urgent', left < 3600000); // last hour: clocks turn sale-red (phase 2)
    var p = parts(left);
    // only clocks on screen: rolling hidden digits changed the DOM every second and woke every page-wide observer
    document.querySelectorAll('[data-pm-count="h"], [data-pm-count="m"], [data-pm-count="s"]').forEach(function (el) { if (el.getClientRects().length) setRoll(el, p['hms'.indexOf(el.getAttribute('data-pm-count'))]); });
  }

  /* ---------- strip marquee: two identical sets, moves right (RTL) at a constant px/s ---------- */
  function initStrip(el) {
    var b = el.querySelector('.vs-b');
    if (!b || b.getAttribute('data-ready')) return;
    b.setAttribute('data-ready', '1');
    var set = b.innerHTML;
    b.insertAdjacentHTML('beforeend', set.replace(/<span class="vs-i/g, '<span aria-hidden="true" class="vs-i'));
    function measure() {
      var w = b.scrollWidth / 2, sp = parseFloat(getComputedStyle(el).getPropertyValue('--speed')) || 28;
      if (!w) return;
      b.style.setProperty('--dist', w + 'px');
      b.style.setProperty('--dur', (w / sp).toFixed(2) + 's');
    }
    b.querySelectorAll('img').forEach(function (i) { if (!i.complete) i.addEventListener('load', measure, { once: true }); });
    // the glint on the big discounts runs only on items now in view (its gradient text repaints every frame)
    if ('IntersectionObserver' in window) {
      var vis = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('pmc-off', !e.isIntersecting); });
      });
      b.querySelectorAll('.vs-i.hot').forEach(function (i) { vis.observe(i); });
    }
    (document.fonts ? document.fonts.ready : Promise.resolve()).then(measure);
    window.addEventListener('resize', measure, { passive: true });
    measure();
  }

  /* ---------- home hero: rotate the scenes every 5s; pause on keyboard focus and in background tabs ---------- */
  function initHero(hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.pmc-hero__slide'));
    if (slides.length < 2) return;
    var i = 0, paused = false;
    // later scenes load once the page is idle, so the first paint only waits for scene 1
    function loadRest() { slides.forEach(function (s) { var img = s.querySelector('img[loading="lazy"]'); if (img) img.loading = 'eager'; }); }
    if (document.readyState === 'complete') loadRest(); else window.addEventListener('load', loadRest, { once: true });
    // Ran 04.11: no pause on hover, the scenes keep turning; keyboard focus still pauses them (accessibility)
    hero.addEventListener('focusin', function () { paused = true; });
    hero.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden || root.classList.contains('pm-campaign-ended')) return;
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 5000);
  }

  /* ---------- phase 2 · micro-animations: sale-card badge pop-in, featured tick, wishlist burst ---------- */
  function initFx() {
    root.classList.add('pmc-fx');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        var k = 0;
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.style.setProperty('--pmc-d', Math.min(k++, 6) * 0.06 + 's');
          e.target.classList.add('pmc-seen');
          io.unobserve(e.target);
        });
      }, { threshold: 0.35 });
      // only cards watched here start hidden (CSS .pmc-watch), so cards the theme renders later stay visible
      document.querySelectorAll('.pmc-grid > .grid-product').forEach(function (c) { c.classList.add('pmc-watch'); io.observe(c); });
      // looping effects run only while on screen
      var vis = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('pmc-off', !e.isIntersecting); });
      }, { rootMargin: '100px' });
      document.querySelectorAll('.pmc-grid > .grid-product, .pmc-gift').forEach(function (c) { vis.observe(c); });
    }
    // the wishlist heart's beat + plumes now live in snippets/pampas-wishlist.liquid (every card)
  }

  function start() {
    if (END - now() <= 0) { end(); return; }
    initFx();
    document.querySelectorAll('.pmc-strip').forEach(initStrip);
    document.querySelectorAll('.pmc-hero').forEach(initHero);
    tick();
    timer = setInterval(tick, 1000);
  }
  // REQ-023: a campaign with a future start time waits (html.pm-campaign-pending) for the head script's switch
  function boot() {
    if (root.classList.contains('pm-campaign-pending')) window.addEventListener('pm:campaign-live', start, { once: true });
    else start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
